var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Component 1"},React.createElement("path",{"id":"Vector","d":"M12.0002 12.95L16.9502 7.99995L18.3642 9.41395L12.0002 15.778L5.63623 9.41395L7.05023 7.99995L12.0002 12.95Z","fill":"#E3E0E7"})));
}

ChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
